<template>
  <div class="page_container">
      <div class="page_path row">
        <div class="banner_content" >
          <!-- <video class="banner_video" width="100%" autoplay="true" loop="" muted="true" playsinline="true"  src="https://cdn.shopify.com/videos/c/o/v/dd7d0ab2c734422c8676dc7a2c3b5ed2.mp4">
            <source type="video/mp4"
              src="https://cdn.shopify.com/videos/c/o/v/dd7d0ab2c734422c8676dc7a2c3b5ed2.mp4">
          </video> -->
        <!-- <img style='width:100%;height:100%;' srcset="https://api.houdinisportswear.com/_images/72d9e0c1-63c4-455e-940f-38fba110a73f/S24_Kids_back_to-School_hero_1.jpg?width=320&quality=90 320w, https://api.houdinisportswear.com/_images/72d9e0c1-63c4-455e-940f-38fba110a73f/S24_Kids_back_to-School_hero_1.jpg?width=640&quality=90 640w, https://api.houdinisportswear.com/_images/72d9e0c1-63c4-455e-940f-38fba110a73f/S24_Kids_back_to-School_hero_1.jpg?width=750&quality=90 750w, https://api.houdinisportswear.com/_images/72d9e0c1-63c4-455e-940f-38fba110a73f/S24_Kids_back_to-School_hero_1.jpg?width=1080&quality=90 1080w, https://api.houdinisportswear.com/_images/72d9e0c1-63c4-455e-940f-38fba110a73f/S24_Kids_back_to-School_hero_1.jpg?width=1920&quality=90 1920w"> -->
        <img class='hidden-xs' src='https://api.houdinisportswear.com/_images/72d9e0c1-63c4-455e-940f-38fba110a73f/S24_Kids_back_to-School_hero_1.jpg?width=1920&quality=90'>
        <img class='visible-xs' src='https://api.houdinisportswear.com/_images/10b7a513-1345-41f1-8deb-d2d399548405/S24_Kids_back_to-School_hero_2.jpg?width=1920&quality=90'>
        <div class="small_banner">
            <div class="small_banner_container">
              <div class="small_banner_title">Back to School</div>
              <div class="small_banner_p">High performance Houdini favorites, just in smaller sizes</div>
              <div class="small_banner_btn tree_button default_btn" @click="toCategory('kids')">Explore</div>
            </div>
          </div>
        </div>
      </div>
      <div class="page_width t_container">
        <!-- <div class="page_title">New & Now</div> -->
        <div class="t_container hidden-xs">
          <div class="swiper-page_container t_swiper">
    
            <div class="swiper-wrapper">
           
              <div class="swiper-slide swiper_slider" v-for="(i,index) in goodsList" :key="index">
                <div class="thumb_goods" @click="toDetails(i.id,i.product_query_id)">
                  <div class="goods_cont" >
                    <div class="good_image"  @mouseenter="backShow(index)" @mouseleave="backHide(index)">
                      <img :src="i.frontImage+'?width=640&quality=90'" alt="" class='frontImage' :class="'frontImage'+index">
                      <img :src='i.backImage+"?width=640&quality=90"' class='backImage visible_none' :class="'backImage'+index">
                      <div class="shop_it" ><p v-for="(s,sid) in i.sizes" :key='sid'>{{s}} </p></div>
                    </div>
                    <div class="good_title">{{ i.name }}</div>
                    <p class='goods_des'>{{i.description}}</p>
                    <div class="good_amount">$ {{ i.amount }}</div>           
                    <div class='good_colors'> <span v-for="(c,idx) in i.colors" :key='idx' :style='{background:c.color_hex}' ></span> </div>
                  </div>
                </div>  
              </div>               
            </div>
          </div>
          <div class="swiper_button_prev iconfont icon-back-line-free"></div>
          <div class="swiper_button_next iconfont icon-enter-line-free"></div>
        </div>
        <div class="mobile_t_container visible-xs" >
          <div class="swiper-page_container mobile_swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide swiper_slider" v-for="(i,index) in goodsList" :key="index">
                <div class="mobile_thumb_goods" @click="toDetails(i.id,i.product_query_id)">
                  <div class="goods_cont">
                    <img :src="i.frontImage+'?width=640&quality=90'" alt="">
                    <div class="good_title">{{ i.name }}</div>
                    <p class='goods_des'>{{i.description}}</p>
                    <div class="good_amount">$ {{ i.amount }}</div>
                    <div class='good_colors' > <span v-for="(c,idx) in i.colors" :key='idx' :style='{background:c.color_hex}' ></span> </div>
                  </div>
                </div>
              </div> 
            </div>
           
          </div>  
            <!-- <div class="swiper_button_prev glyphicon glyphicon-menu-left"></div>
            <div class="swiper_button_next glyphicon glyphicon-menu-right"></div> -->
         
        </div>
        
      </div>
      <!-- <div class="page_width t_container">
        <div class="postcard grid">
          <div class="postcard_text" >
            <div class="postcard_text_title">Suit Yourself</div>
            <div class="postcard_text_info">These suit separates make a coordinated effort to elevate your wardrobe with chic blazers, flattering crop tops and stylish shorts to match!</div>
            <div class="postcard_btn tree_button default_btn" @click="toCategory('shirts')">shop now</div>
          </div>
          <div class="postcard_image">
           
          </div>
        </div>
      </div> -->
      <div class="page_path row" style='padding:50px 0'>
        <div class="banner_content" >
          <img class='hidden-xs' src='https://api.houdinisportswear.com/_images/261a0ee7-f6e2-4c86-8789-173795568eb3/S24_Summer-Hiking-banner-horizontal.jpg?width=1920&quality=90'>
          <img class='visible-xs' src='https://api.houdinisportswear.com/_images/79e2c69a-3469-4201-9509-351fdea14fda/S24_Summer-Hiking-banner-vertical.jpg?width=1920&quality=90'>
          <div class="small_banner">
            <div class="small_banner_container">
              <div class="small_banner_title">Summer Hiking</div>
              <div class="small_banner_p">the designed for lightness, functionality and maximal versatility.</div>
              <div class="small_banner_btn tree_button default_btn" @click="toCategory('hiking')">explore</div>
            </div>
          </div>
        
        
        </div>
      </div>
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import $ from 'jquery'
export default {
 name: 'home',
 data(){
  return {

  }
 },
 created(){
  this.$store.dispatch('getGoods',{name:'women',size:20})

 },
 computed: {
  goodsList(){  return this.$store.state.goodsList}
 },
 methods:{
    toDetails(id,url){
      this.$router.push('/details?id='+id+'&product='+url)      
    },
    initSwiper(){
      let that = this
     
      if(this.goodsList.length==0){
        setTimeout(() => {
          that.initSwiper()
          return
        }, 1000);
      }
      this.$nextTick(()=>{    
        new Swiper('.t_swiper', {
        // Optional parameters
          loop: true,
          slidesPerView:4,
          slidesPerGroup: 1,
          // autoplay: 500,
          prevButton:'.swiper_button_prev',
          nextButton:'.swiper_button_next',
        });
      })
    },
    initMobileSwiper(){
      this.$nextTick(()=>{
        new Swiper('.mobile_swiper', {
        // Optional parameters
          loop: true,
          slidesPerView:2,
          slidesPerGroup: 1,
          prevButton:'.swiper_button_prev',
          nextButton:'.swiper_button_next',
        });
      })
    },
    backShow(id){
        $('.backImage'+id).addClass('visible_block').removeClass('visible_none')
    },
    backHide(id){
        $('.backImage'+id).addClass('visible_none').removeClass('visible_block')
    },
    toCategory(path){
      this.$router.push('/category?categoryName='+path)
    }

 },
 mounted(){
 
   this.initSwiper() 
   this.initMobileSwiper()
 },
}
</script>

<style lang='scss' scoped>
  .page_path{   
    .banner_content{
     position:relative;
   
       .banner_video{
        width:100%;
        height:auto;
       }
    }
  }
 .page_title{
    width:100%;
    text-align: center;
    color:#000;
    font-size:32px;
    font-family: Americana, serif;
    text-transform: uppercase;
    line-height: 1.3;
    letter-spacing: 5px;
    margin-top:20px;
    font-weight: 600;
 }
 .t_container{
    margin-top:20px;
    position: relative;
     .swiper_button_prev,.swiper_button_next{
      position:absolute;
      // border:1px solid #000;
      font-size:16px;
      width:18px;
      // height:40px; 
      top:40%;
      right:0;
      z-index:99;
      line-height:40px;
     }
     .swiper_button_prev{
      left:0;
     }
   .t_swiper{
     padding:45px 0px 0;
     margin:0 30px;
     position:relative;
    overflow: hidden;
  }
  .thumb_goods{
    margin:0 20px;
    cursor:grab;
    .good_image{
      position: relative;
      overflow: hidden;
      cursor: pointer;
      &:hover{
        .shop_it{
          opacity: 1;
          bottom:0;
          transition: all .25s ease-in-out;
        }
        
      }
      .backImage{
          position: absolute;
          top:0;
          bottom:0;
          left:0;
          right:0;
      }
      .backImage, .frontImage{
          transition: opacity .35s ease-in-out;
          // max-height:400px;
          width:100%;
      }
      .shop_it{
        position: absolute;    
        left:0;
        right:0;
        background-color: rgb(249, 249, 249);
        padding:4px 10px;
        bottom: 0px;
        opacity: 0;
        text-align: center;
        width: 100%;
        transition: all .25s ease-in-out;
        text-transform: uppercase;
        cursor: pointer;
        letter-spacing:0;
        >p{
          display:inline-block;
          padding:2px 4px;
          font-size:12px;
          margin:0;
        }
        &:hover{
          background:#fff;
          color:#666;
        }
      }
    }
    
    
  }
  
 }
 .mobile_thumb_goods{
    margin:0 10px;
  }
 .mobile_t_container{
  margin-top:20px;
  // padding:0 20px;
  position:relative;
  .mobile_swiper{
    // margin:0 30px;
    position:relative;
  }
 }
 .good_title{
    font-family: neo-sans, "Helvetica Neue", Helvetica, Arial, sans-serif;
    text-align: center;
    margin-top:15px;
    margin-bottom:12px;
    font-weight: 600;
    color:#000;
    
    
  }
  .goods_des{
    min-height:35px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    font-family: goudy-old-style, Georgia, serif;
    font-size: 12px;
    text-overflow: ellipsis;
    line-height: 1.43;
    overflow: hidden;
    
  }
  .good_amount{
    margin-top:10px;
    font-weight:600;
    color:#000;
  }
  .good_colors{
    // height:30px;
    margin-top:10px;
    >span{
      display:inline-block;
      width:16px;
      height:16px;
      margin:2px 4px;
      border-radius:50%;
      // padding:4px;
      // border:1px solid #ccc;
      cursor:pointer;
      // box-shadow: rgb(141, 141, 141) 0px 0px 0px 1px inset, rgb(255, 255, 255) 0px 0px 0px 3px inset;
    }
  }
  .postcard{
    
    .postcard_text{
      color: #634964;
      background-color: #faf7f2;
      padding:60px 5% 100px;
      text-align: center;
      grid-column-start:span 5;
    
    .postcard_text_title{
      font-size:3em;
      font-family: Americana,serif;
      font-weight: 400;
      letter-spacing: 5px;
      text-transform: uppercase;
      margin:10px 0;
    }
    .postcard_text_info{
      color:#634964;
      font-family: Montserrat,sans-serif;
      line-height:1.6;
      margin:30px auto 0;
      width:80%;
    }
    .postcard_btn{
      margin-top:40px;
      color:#634964;
      border-color:#634964;
      &:hover{
        color:#fff;
        background:#634964;
      }
    }
    }
    .postcard_image{

 
      grid-column-start:span 7;
      background-image:url('https://cdn.shopifycdn.net/s/files/1/2483/6632/files/Suiting-CatgoryPush_1080x.jpg?v=1680536373');
      background-position:center center !important;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
  .small_banner{
    // background: url('https://cdn.shopify.com/s/files/1/2483/6632/files/NewMarkdown_Desktop.jpg?v=1678981577') no-repeat;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position-y: center;
    position:absolute;
    left:0;
    right:0;
    left:0;
    bottom:0;
    background:rgba(#000,0.2);
  
    .small_banner_container{
      
      height:100%;
      color:#fff;
      display:flex;
      flex-direction:column;
      justify-content:center;
      align-items:center;
      .small_banner_title{
        font-size: calc(36px + 34 * ((100vw - 400px) / 624));
        font-family: neo-sans, "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: 400;
        margin:10px 0;
      }
      .small_banner_p{
        font-family: goudy-old-style, "Arial Narrow", serif;
        font-weight: 400;
        margin-top: 10px;
        margin-bottom: 30px;
        font-size:22px;
        max-width:75%;
        line-height:1.4;
      }
      .small_banner_btn{
        background:rgba($color: #fff, $alpha:0);
        border:1px solid #fff;
        color:#fff;
        // border:none;
        padding:0 35px;
        margin-top:30px;
        &:hover{
          background:#fff;
          color:#000;
          
        }
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/view/index/home.vue